export const normalizeSalesChannelName = (salesChannel: string) => {
    return salesChannel?.toLowerCase()?.includes("synth")
        ? "Retail"
        : salesChannel?.toLowerCase()?.includes("trackstar.")
        ? salesChannel?.split(".")[1]
        : salesChannel;
};
